import { Boilerplate } from "@/components/landing/Boilerplate";
import { Comparsion } from "@/components/landing/Comparsion";
import { Cta } from "@/components/landing/Cta";
import { FAQ } from "@/components/landing/FAQ";
import { Features } from "@/components/landing/Features";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { MarketingShell } from "@/components/landing/MarketingShell";
import { Problems } from "@/components/landing/Problems";
import { ScrollToTop } from "@/components/landing/ScrollToTop";
import { Templates } from "@/components/landing/Templates";
import { Testimonials } from "@/components/landing/Testimonials";
import { Video } from "@/components/landing/Video";
import { useSession } from "@/components/useSession";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

function Page() {
  const router = useRouter();
  const { status } = useSession();
  const [stay, setStay] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setStay(window.document.location.hash === "#stay");
    }
  }, []);

  if (stay === false) {
    if (status === "authenticated") {
      router.push("/dashboard", undefined, { shallow: true });
      return;
    }
  }

  return (
    <MarketingShell className="flex flex-col justify-center">
      <Hero />
      <div className="pt-15 md:pt-0 pb-15 md:pb-40">
        <Video />
      </div>
      <Problems />
      <div className="flex flex-col gap-20 md:gap-30 pt-20 mb-20">
        <HowItWorks />
        <Features />
        <Boilerplate landing />
        <Templates landing />
        <Testimonials />
        <Comparsion />
        <Cta />
        <FAQ limit={5} />
        <ScrollToTop />
      </div>
    </MarketingShell>
  );
}

export default Page;
